/**
 * 入力文字列が数値として不完全な状態（編集途中）かどうかを判定する。
 */
export const isPartialInput = (trimmed: string, decimalScale: number): boolean => {
  if (decimalScale <= 0) return false
  // 末尾が「.」または「.」+ decimalScale 桁未満の数字（例: "1.", "1.5" は decimalScale=2 なら入力途中）
  return new RegExp(`^-?\\d+\\.\\d{0,${decimalScale - 1}}$`).test(trimmed)
}

/**
 * 入力文字列を number | undefined へ正規化する。
 */
export const parseNumeric = (value: string, decimalScale = 0): number | undefined => {
  const trimmed = value.trim()
  if (trimmed === '') return undefined

  if (!/^-?\d+(\.\d+)?$/.test(trimmed)) return undefined
  const parsed = Number(trimmed)
  if (Number.isNaN(parsed)) return undefined
  const factor = 10 ** decimalScale
  return Math.trunc(parsed * factor) / factor
}

/**
 * 入力文字列が decimalScale の桁数を超える小数かどうかを判定する。
 */
export const exceedsDecimalScale = (trimmed: string, decimalScale: number): boolean => {
  if (decimalScale <= 0) return /^-?\d+\.\d+$/.test(trimmed)
  return new RegExp(`^-?\\d+\\.\\d{${decimalScale + 1},}$`).test(trimmed)
}
